import { AxiosResponse } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awBffApi } from './Base';

export async function getLoginByFaId(faId: string): Promise<AxiosResponse<string>> {
  const path = `view-as/${faId}`;
  const response = await awBffApi.get<AGraphWrappedType<string, 'viewAs'>>(path);
  return unwrapAGraphResponse(response, 'viewAs');
}
